import { parseInAppSearch } from './assistInspectionIntent.js';

// Shared by both voice entry points. Completed actions do not erase the user's
// selected application; no action is initiated by this context alone.
export function createAppTaskContext() {
  let app = '';
  return {
    resolve(text, {voice=false,history=[]}={}) {
      const raw=String(text || '').trim();
      // Whisper can collapse the wake name into "I". Only repair the exact
      // voice-only, benign named-app launch shape; never general statements.
      const q=voice ? raw.replace(/^(?:I|Area)\s+(open(?: up)?|launch)\s+(Google Earth|Google Maps|Chrome|Edge|Firefox|Notepad|Excel|Word)([.!]?)$/i,'$1 $2$3') : raw;
      const command=q.replace(/^(?:(?:aria|hey|please)[,.!\s]+)+/i,'')
        .replace(/^(?:(?:i (?:need|want)(?: you)? to|can you|could you)\s+)+/i,'');
      if (/^(?:stop|cancel|end (?:this|the) task|(?:we(?:'re| are)|i(?:'m| am)) done|new task|start over)[.!\s]*$/i.test(command)) {
        app=''; return q;
      }
      const search=parseInAppSearch(command);
      if(search) { app=search.app; return `In ${app}, search for ${search.query}`; }
      const named=command.match(/^(?:in|on|inside)\s+(Google Earth|Google Maps|Chrome|Edge|Firefox|Notepad|Excel|Word)[,;:.!\s]+(?:click|type|scroll|press|select|zoom)\b/i)
        || command.match(/^(?:open(?: up)?|launch|big ?screen|maximi[sz]e)\s+(Google Earth|Google Maps|Chrome|Edge|Firefox|Notepad|Excel|Word)[.!?\s]*$/i);
      if(named) {app=named[1]; return command;}
      // An explicit trailing destination is also user context. Retain it for
      // follow-ups, but never borrow a previous app when a new destination was
      // supplied and could not be recognized (for example, uncertain speech).
      const trailing=command.match(/^(?:click|type|scroll|press|select|zoom)\b[^"“”]*\b(?:in|inside|on)\s+(Google Earth|Google Maps|Chrome|Edge|Firefox|Notepad|Excel|Word)[.!\s]*$/i);
      if(trailing && !/\b(?:if|when|don't|do not|never|said|says)\b/i.test(command)) {
        app=trailing[1]; return command;
      }
      if (/^(?:click|type|scroll|press|select|zoom)\b[\s\S]*\b(?:in|inside|on)\s+\S/i.test(command)) { app=''; return q; }
      // Resolve an explicit imperative from the user's own recent context,
      // never from an assistant suggestion or text read from the screen.
      if (!/["“”]|\b(?:if|when|don't|do not|never|said|says)\b/i.test(command)
          && /(?:^|[.!]\s+)(?:please\s+)?open it up[.!]*$/i.test(command)) {
        if(!app) {
          const lastUser=[...history].reverse().find(turn=>turn.role==='user');
          const antecedent=String(lastUser?.content || '').match(/^(?:I\s+)?open(?: up)?\s+(Google Earth|Google Maps|Chrome|Edge|Firefox|Notepad|Excel|Word)[.!]?$/i);
          if(antecedent) app=antecedent[1];
        }
        if(app) return `Open ${app}.`;
      }
      // Explicit destinations and web research always override retained context.
      if (/\b(?:in|inside|on)\s+(?:Google|Chrome|Edge|Firefox|Notepad|Excel|Word)\b|\b(?:online|web|google for|search google)\b/i.test(command)) return q;
      if(app && /^search(?: for)?\s+\S/i.test(command)) return `In ${app}, ${command}`;
      if(app && /^(?:click|type|scroll|press|select|zoom)\b/i.test(command)) return `In ${app}, ${command}`;
      if(app && /^(?:big ?screen it|make it (?:bigger|full screen))[.!\s]*$/i.test(command)) return `Maximize ${app}.`;
      return q;
    },
    current:()=>app,
  };
}
export const appTaskContext=createAppTaskContext();
